import Redact from "redact-object";

const DEFAULT_SANITIZE_KEYS = [
  "password",
  "secret",
  "token",
  "credit_card",
  "gateway",
  "exp_",
  "last4",
  "billing_details",
];

type WhitelistedUrl = string | RegExp;

interface EventScrubberOptions {
  sanitizeKeys?: string[];
  whitelistedUrls?: WhitelistedUrl[];
}
class EventScrubber {
  private sanitizeKeys: string[];
  private whitelistedUrls: WhitelistedUrl[];
  name = "EventScrubber";

  /**
   * @inheritDoc
   */

  constructor(options: EventScrubberOptions) {
    const { sanitizeKeys = DEFAULT_SANITIZE_KEYS, whitelistedUrls } = options || {};
    this.sanitizeKeys = sanitizeKeys;
    this.whitelistedUrls = whitelistedUrls;
  }

  setupOnce = (addGlobalEventProcessor) => {
    // to support previous version of sentry
    if (typeof addGlobalEventProcessor === "function") {
      addGlobalEventProcessor((event) => {
        if (!event) {
          return null;
        }
        if (this.whitelistedUrls?.length) {
          // NOTE - this is only used for sm-shop, for nextjs verticals we are using allowUrls config in packages/services/sentry-nextjs/config/client.js
          const eventFrames = event.exception?.values?.[0]?.stacktrace?.frames || [];
          const isWhiteListedFile = eventFrames.length
            ? eventFrames.some(({ filename }: { filename?: string } = {}) =>
                this.whitelistedUrls.some((url: WhitelistedUrl) =>
                  url instanceof RegExp ? url.test(filename) : filename?.includes(url),
                ),
              )
            : true;

          if (!isWhiteListedFile) {
            return null;
          }
        }

        return Redact(event, this.sanitizeKeys, undefined, { partial: true, ignoreUnknown: true });
      });
    }
  };

  setup(client) {
    client.addEventProcessor((event) => {
      if (this.whitelistedUrls?.length) {
        // NOTE - this is only used for sm-shop, for nextjs verticals we are using allowUrls config in packages/services/sentry-nextjs/config/client.js
        const eventFrames = event.exception?.values?.[0]?.stacktrace?.frames || [];
        const isWhiteListedFile = eventFrames.length
          ? eventFrames.some(({ filename }: { filename?: string } = {}) =>
              this.whitelistedUrls.some((url: WhitelistedUrl) =>
                url instanceof RegExp ? url.test(filename) : filename?.includes(url),
              ),
            )
          : true;

        if (!isWhiteListedFile) {
          return null;
        }
      }

      return Redact(event, this.sanitizeKeys, undefined, { partial: true, ignoreUnknown: true });
    });
  }
}

export default EventScrubber;
